module.exports = __webpack_public_path__ + "img/warning.05b36232.png";